import { Divider, Grid } from "@mui/material";
import { fetchProducts } from "actions/productActions";
import { selectCartCount, selectProducts } from "features/hardware/products";
import { useApiOnce, useAppSelector } from "hooks/hooks";
import { UserDetails } from "../UserDetails";
import styles from "./Summary.module.scss";
import { SummaryCart } from "./SummaryCart";

/**
 * @param {Object} props
 * @param {(newData: import("types").FormEmployee) => void} props.saveForm - Function to save the form data
 * @param {import("types").NewEmployeeFormFields} props.newEmployeeData - The employee data object
 */
const Summary = ({ saveForm, newEmployeeData }) => {
	const cartItemsCount = useAppSelector(selectCartCount);

	useApiOnce(fetchProducts, useAppSelector(selectProducts));

	return (
		<Grid container classes={{ root: styles.summaryWrapper }}>
			<Grid item xs={12} className={styles.userDetails}>
				<UserDetails
					employeeData={newEmployeeData}
					setIsFormDataDirty={() => {}} // Prevents isDirty reset. Data already dirty from previous step.
					showShippingDetails={cartItemsCount > 0}
					saveForm={saveForm}
				/>
			</Grid>
			<Divider orientation="vertical" flexItem />
			<Grid
				container
				direction="column"
				item
				xs={5}
				classes={{ root: styles.summaryCartWrapper }}
			>
				<Grid item xs={5} classes={{ root: styles.summaryCart }}>
					<SummaryCart
						chosenLicenses={newEmployeeData.chosenLicenses ?? []}
						shouldShowLicenses={newEmployeeData.chosenLicenses?.length > 0}
						shouldShowProducts={cartItemsCount > 0}
					/>
				</Grid>
				<Divider />
			</Grid>
		</Grid>
	);
};

export { Summary };
